/* eslint-disable */
// prettier-ignore
import jwtDefaultConfig from '@/auth/jwt/jwtDefaultConfig'
import ability from '@/libs/acl/ability'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * Verifica se o usuário possui permissão para realizar uma ação específica em uma rotina (recurso do sistema).
 *
 * @param {number} rotinaId - ID da rotina, baseado no mapeamento interno (ex: 1-'situacaofiscal_federal').
 * @param {number} tipoAction - Código da ação a ser validada: 1-"create", 2"read", 3-"update", 4-"delete".
 * @returns {boolean} Retorna `true` se o usuário possuir a permissão especificada para a rotina; caso contrário, `false`.
 */
export const abilityValidation = (rotinaId, tipoAction) => {

  const actionMap = {
    1: 'create',
    2: 'read',
    3: 'update',
    4: 'delete'
  }

  const rotinasMap = {
    1: 'situacaofiscal_federal',
    2: 'declaracao_dctfweb',
    3: 'comprovante_pagamento',
    4: 'cnd_federal',
    5: 'cnd_fgts',
    6: 'cnd_trabalhista',
    7: 'cnd_mte',
    8: 'cnd_estadual',
    9: 'cnd_municipal',
    10: 'caixapostal_ecac',
    11: 'das_parcelamento',
    12: 'parcelamento_pertsn',
    13: 'parcelamento_relpsn',
    14: 'parcelamento_rfb',
    15: 'parcelamento_naoprevidenciario',
    16: 'parcelamento_simp_previdenciario',
    17: 'das',
    18: 'sublimite',
    19: 'pgfn_parcelamento',
    20: 'portal_documentos',
    21: 'cnd_portal_documentos',
    22: 'monitoramento_360',
    23: 'certificadodigital',
    24: 'usuario',
    25: 'empresa',
    26: 'perfil_empresa',
    27: 'emailconfig',
    28: 'parametro_sistema',
    29: 'plano',
    30: 'aquisicao_credito',
    31: 'relatorio_consumo',
    32: 'caixapostal_dte',
    33: 'parcelamento_das_mei',
    34: 'parcelamento_pert_mei',
    35: 'parcelamento_relp_mei',
    36: 'envio_automatico',
    37: 'pg_mei',
  }

  const action = actionMap[tipoAction]
  const rotina = rotinasMap[rotinaId]

  if (!action || !rotina) {
    return false
  }

  const userDataraw = localStorage.getItem('userData')

  if (!userDataraw) {
    return false
  }

  let userData
  try {
    userData = JSON.parse(userDataraw)
  } catch {
    return false
  }

  const abilitys = userData.ability
  if (!Array.isArray(abilitys)) {
    return false
  }

  return abilitys.some(ability => ability.subject === rotina && ability.actions.includes(action))
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'autenticacao' }
}

export const getUserInfo = () => {
  const data = getUserData()
  return data ? { nome: data.username, empresa: data.empresa, usuarioId: data.usuarioId } : {}
}

export const isGoingToLogging = (from, to) => {
  const fromDiffPaths = from.name !== to.name
  return fromDiffPaths && (to.path.startsWith('/login'))
}

/**
 * Limpa todos os dados de autorização
 */
export const clearLoggedIn = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem(jwtDefaultConfig.storageTokenKeyName)
  localStorage.removeItem(jwtDefaultConfig.storagePermissoes)
}

export const isGoingToHome = (from, to) => {
  const fromDiffPaths = from.name !== to.name
  return fromDiffPaths && (to.path === '/')
}

export const isAdmin = () => {
  const userData = getUserData()
  return userData && userData.admin
}

export const isDemo = () => {
  const userData = getUserData()
  return userData && userData.baseDemo
}

export const updateAbility = ability => {
  const userData = getUserData()
  const existingAbility = userData ? userData.ability : null
  ability.update(existingAbility || [])
}
